export const SKINS = {
  fluxlab: {
    label: "Flux Lab",
    panel: "bg-[#131f3a] border-white/5",
    card: "bg-white/[0.02] border-white/5 hover:border-[#f59e0b]/20",
    title: "text-white font-display",
    desc: "text-gray-300",
    chip: "text-[#f59e0b] bg-[#f59e0b]/5 border-[#f59e0b]/20",
    rail: "border-white/5",
  },
  courtroom: {
    label: "Courtroom",
    light: true,
    panel: "bg-[#f5f1e6] border-[#d6cdb8]",
    card: "bg-white border-[#d6cdb8] hover:border-[#8b7d5a]",
    title: "text-[#1f2937] font-serif",
    desc: "text-[#4b5563]",
    chip: "text-[#7c5e10] bg-[#7c5e10]/10 border-[#7c5e10]/30",
    rail: "border-[#d6cdb8]",
  },
  storybook: {
    label: "Storybook",
    panel: "bg-[#2b1e2e] border-[#fb7185]/15",
    card: "bg-[#fb7185]/[0.06] border-[#fb7185]/15 hover:border-[#fbbf24]/40",
    title: "text-[#fef9ec] font-display",
    desc: "text-[#efd9e2]",
    chip: "text-[#fbbf24] bg-[#fbbf24]/10 border-[#fbbf24]/30",
    rail: "border-[#fb7185]/20",
  },
  neon: {
    label: "Neon Chrono",
    panel: "bg-[#060913] border-[#2dd4bf]/20",
    card: "bg-[#2dd4bf]/[0.04] border-[#2dd4bf]/15 hover:border-[#2dd4bf]/50",
    title: "text-[#2dd4bf] font-display",
    desc: "text-gray-300",
    chip: "text-[#a78bfa] bg-[#a78bfa]/10 border-[#a78bfa]/30",
    rail: "border-[#2dd4bf]/20",
  },
};

export const TRACKS = [
  { key: "support", label: "💵 Support Track", cls: "bg-blue-950/40 border-blue-500/20 text-blue-400 accent-blue-500", lightCls: "bg-blue-50 border-blue-500/50 text-blue-800 accent-blue-600" },
  { key: "safety", label: "🛡️ Safety Incidents", cls: "bg-rose-950/40 border-rose-500/20 text-rose-400 accent-rose-400", lightCls: "bg-rose-50 border-rose-500/50 text-rose-800 accent-rose-600" },
  { key: "family", label: "👶 Milestone Events", cls: "bg-emerald-950/40 border-emerald-500/20 text-emerald-400 accent-emerald-400", lightCls: "bg-emerald-50 border-emerald-500/50 text-emerald-800 accent-emerald-600" },
  { key: "procedural", label: "⚖️ Procedural Setup", cls: "bg-purple-950/40 border-purple-500/20 text-purple-400 accent-purple-400", lightCls: "bg-purple-50 border-purple-500/50 text-purple-800 accent-purple-600" },
];

export const TRACK_ACCENT = {
  support: "border-l-blue-500",
  safety: "border-l-rose-500",
  family: "border-l-emerald-500",
  procedural: "border-l-purple-500",
};

export function eventShape(ev) {
  const txt = `${ev.title} ${ev.description || ""}`.toLowerCase();
  if (/hearing|trial date|arraignment|court date/.test(txt)) return "hearing";
  if (/filed|filing|motion|petition|order|judgment|declaration/.test(txt)) return "filing";
  if (ev.status === "alert") return "incident";
  return "default";
}
